/* eslint-disable no-console */

import { register } from 'register-service-worker'

// Whether a service worker already controlled this page when it loaded. Used
// to distinguish an UPDATE (replacing an existing controller → safe to reload
// so the user runs the freshly deployed bundle) from a FIRST install (a brand
// new visitor → must NOT reload). Captured before registration runs.
const hadControllerAtStartup =
  'serviceWorker' in navigator && !!navigator.serviceWorker.controller

if (process.env.NODE_ENV === 'production') {
  // With workbox skipWaiting + clientsClaim, a new deploy activates its service
  // worker immediately and fires `controllerchange`. Reload once (updates only)
  // so the open tab picks up the new bundle without a manual hard-refresh —
  // this is what was keeping users on stale, already-fixed code.
  let refreshing = false
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing || !hadControllerAtStartup) return
      refreshing = true
      window.location.reload()
    })
  }

  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated () {
      console.log('New content is available; activating and reloading to the latest version.')
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
